// Modules
import { ChevronRight, AgExams, MedicalCalendar } from '@dasa-health/alma-icons'
import { Spacing, Overline } from '@dasa-health/alma-react'
import React, { useEffect, useState } from 'react'
import { CustonModalOrBootomSheet } from 'redesign/components/molecules/CustomModalOrBottomSheet'
import { CustomModalOrBottomSheetLogin } from 'redesign/components/molecules/CustomModalOrBottomSheetLogin'
import Vector from 'assets/Vector.svg'

// Component
import {
    Container,
    Border,
    ButtonContainer,
    Chevron,
    Button,
    Icon,
    AccessText,
    VectorImg,
    TitleLaboratory,
    ContainerCarousel,
} from './styles'
import { LogoCarouselContainer } from 'components/LogoCarousel/styles'
import LogoCarousel from 'components/LogoCarousel'

type EasyAccessContainerProps = {
    showButtons?: boolean
}

export const EasyAccessContainer = ({ showButtons = true }: EasyAccessContainerProps) => {
    const [showModalOrBottomSheetOtp, setShowModalOrBottomSheetOtp] = useState(false)
    const [showScheduleExam, setShowScheduleExam] = useState(false)

    const DATA = {
        title: showScheduleExam ? 'Agendar exames' : 'Conferir resultados de exames',
        subtitle: 'Para continuar, insira o CPF do paciente',
    }

    const handleOpenScheduleExam = () => {
        setShowScheduleExam(true)
        setShowModalOrBottomSheetOtp(true)
        sessionStorage.setItem('@redirectToUrl', '/agd-exames/paciente?origin=Acesso-Facil')
    }

    const handleOpenCheckResult = () => {
        setShowScheduleExam(false)
        setShowModalOrBottomSheetOtp(true)
        sessionStorage.setItem('@redirectToUrl', '/exames?origin=Acesso-Facil')
    }

    useEffect(() => {
        if (!showModalOrBottomSheetOtp) {
            sessionStorage.removeItem('@redirectToUrl')
        }
    }, [showModalOrBottomSheetOtp])

    return (
        <Container>
            <Border />
            <CustonModalOrBootomSheet
                setShowModal={setShowModalOrBottomSheetOtp}
                showCloseButtonModal={false}
                showModal={showModalOrBottomSheetOtp}
                title={DATA.title}
            >
                <p>{DATA.subtitle}</p>
                <CustomModalOrBottomSheetLogin />
            </CustonModalOrBootomSheet>
            <Spacing height={16 + 24} />
            {showButtons && (
                <>
                    <ButtonContainer>
                        <AccessText>
                            <Overline>ACESSO FÁCIL</Overline>
                            <VectorImg alt="Vector" src={Vector} />
                        </AccessText>

                        <Button
                            data-current-service="Login faseado"
                            data-item-position="Acesso rápido"
                            data-item-text="Conferir resultados"
                            data-testid="bottom-sheet-checkResult"
                            onClick={handleOpenCheckResult}
                        >
                            <Chevron>
                                <Icon>
                                    <AgExams />
                                </Icon>
                                <Icon transparent>
                                    <ChevronRight />
                                </Icon>
                            </Chevron>
                            <span>Conferir resultados</span>
                        </Button>
                        <Button
                            data-current-service="Login faseado"
                            data-item-position="Acesso rápido"
                            data-item-text="Agendar exames"
                            data-testid="bottom-sheet-scheduleExam"
                            onClick={handleOpenScheduleExam}
                        >
                            <Chevron>
                                <Icon>
                                    <MedicalCalendar />
                                </Icon>
                                <Icon transparent>
                                    <ChevronRight />
                                </Icon>
                            </Chevron>
                            <span>Agendar exames</span>
                        </Button>
                    </ButtonContainer>
                    <Spacing height={40} />
                </>
            )}

            <ContainerCarousel>
                <TitleLaboratory>Conecto você a laboratórios de todo o país</TitleLaboratory>
                <Spacing height={24} />
                <LogoCarouselContainer>
                    <LogoCarousel />
                </LogoCarouselContainer>
            </ContainerCarousel>
        </Container>
    )
}
